import { Button } from '@atoms';
import { DialogTitle, Typography } from '@mui/material';
import styled from 'styled-components';

export const StyledHeaderModal = styled(Typography)`
  font-size: 24px !important;
  line-height: 20px !important;
`;

export const StyledDialogTitle = styled(DialogTitle)`
  padding: 33px 37px 31px !important;
`;

export const stylesCloseIcon = {
  position: 'absolute',
  right: '16px',
  top: '18px',
  color: '#A3A7B0',
};

export const StyledUndoBtn = styled(Button)`
  font-size: 12px;
  line0height: 9px;
  color: #44aefb;
`;
